/**
 * Impl dos use cases de templates de contrato/certificado (acadadmin).
 *
 * ContratoTipo edita pela linha da lista (sem get); ContratoTemplate/CertificadoTemplate
 * recarregam via get() na edição (HTML completo).
 *
 * @since G.5.18
 */
import type { Page } from '@/domain/model/Page';
import type {
  ContratoTipo, ContratoTipoCommand, ContratoTemplate, ContratoTemplateCommand,
  CertificadoTemplate, CertificadoTemplateCommand,
} from '@/domain/model/Template';
import type {
  ContratoTipoGateway, ContratoTemplateGateway, CertificadoTemplateGateway,
  ListContratoTiposParams, ListContratoTemplatesParams, ListCertificadoTemplatesParams,
} from '@/application/port/out/TemplateGateways';
import type {
  ListContratoTiposUseCase, CreateContratoTipoUseCase, UpdateContratoTipoUseCase, DeactivateContratoTipoUseCase,
  ListContratoTemplatesUseCase, GetContratoTemplateUseCase, CreateContratoTemplateUseCase,
  UpdateContratoTemplateUseCase, DeactivateContratoTemplateUseCase,
  ListCertificadoTemplatesUseCase, GetCertificadoTemplateUseCase, CreateCertificadoTemplateUseCase,
  UpdateCertificadoTemplateUseCase, DeactivateCertificadoTemplateUseCase,
} from '@/application/port/in/TemplateUseCase';

// ─── ContratoTipo ─────────────────────────────────────────────────────────────
export class ListContratoTipos implements ListContratoTiposUseCase {
  constructor(private readonly g: ContratoTipoGateway) {}
  execute(p: ListContratoTiposParams): Promise<Page<ContratoTipo>> { return this.g.list(p); }
}
export class CreateContratoTipo implements CreateContratoTipoUseCase {
  constructor(private readonly g: ContratoTipoGateway) {}
  execute(cmd: ContratoTipoCommand): Promise<ContratoTipo> { return this.g.create(cmd); }
}
export class UpdateContratoTipo implements UpdateContratoTipoUseCase {
  constructor(private readonly g: ContratoTipoGateway) {}
  execute(id: string, cmd: ContratoTipoCommand): Promise<ContratoTipo> { return this.g.update(id, cmd); }
}
export class DeactivateContratoTipo implements DeactivateContratoTipoUseCase {
  constructor(private readonly g: ContratoTipoGateway) {}
  execute(id: string): Promise<void> { return this.g.deactivate(id); }
}

// ─── ContratoTemplate ──────────────────────────────────────────────────────────
export class ListContratoTemplates implements ListContratoTemplatesUseCase {
  constructor(private readonly g: ContratoTemplateGateway) {}
  execute(p: ListContratoTemplatesParams): Promise<Page<ContratoTemplate>> { return this.g.list(p); }
}
export class GetContratoTemplate implements GetContratoTemplateUseCase {
  constructor(private readonly g: ContratoTemplateGateway) {}
  execute(id: string): Promise<ContratoTemplate> { return this.g.get(id); }
}
export class CreateContratoTemplate implements CreateContratoTemplateUseCase {
  constructor(private readonly g: ContratoTemplateGateway) {}
  execute(cmd: ContratoTemplateCommand): Promise<ContratoTemplate> { return this.g.create(cmd); }
}
export class UpdateContratoTemplate implements UpdateContratoTemplateUseCase {
  constructor(private readonly g: ContratoTemplateGateway) {}
  execute(id: string, cmd: ContratoTemplateCommand): Promise<ContratoTemplate> { return this.g.update(id, cmd); }
}
export class DeactivateContratoTemplate implements DeactivateContratoTemplateUseCase {
  constructor(private readonly g: ContratoTemplateGateway) {}
  execute(id: string): Promise<void> { return this.g.deactivate(id); }
}

// ─── CertificadoTemplate ─────────────────────────────────────────────────────────
export class ListCertificadoTemplates implements ListCertificadoTemplatesUseCase {
  constructor(private readonly g: CertificadoTemplateGateway) {}
  execute(p: ListCertificadoTemplatesParams): Promise<Page<CertificadoTemplate>> { return this.g.list(p); }
}
export class GetCertificadoTemplate implements GetCertificadoTemplateUseCase {
  constructor(private readonly g: CertificadoTemplateGateway) {}
  execute(id: string): Promise<CertificadoTemplate> { return this.g.get(id); }
}
export class CreateCertificadoTemplate implements CreateCertificadoTemplateUseCase {
  constructor(private readonly g: CertificadoTemplateGateway) {}
  execute(cmd: CertificadoTemplateCommand): Promise<CertificadoTemplate> { return this.g.create(cmd); }
}
export class UpdateCertificadoTemplate implements UpdateCertificadoTemplateUseCase {
  constructor(private readonly g: CertificadoTemplateGateway) {}
  execute(id: string, cmd: CertificadoTemplateCommand): Promise<CertificadoTemplate> { return this.g.update(id, cmd); }
}
export class DeactivateCertificadoTemplate implements DeactivateCertificadoTemplateUseCase {
  constructor(private readonly g: CertificadoTemplateGateway) {}
  execute(id: string): Promise<void> { return this.g.deactivate(id); }
}
